import apiConfig from "@/../api.config";

let env = window.location.host;
if (!apiConfig[env]) {
    env = "default";
}

let environmentConfig = apiConfig[env];
export default environmentConfig;
